import React, { useState, useEffect } from "react";
import "../styles/Hero.css";

const Hero = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const conferenceDate = new Date("2026-07-09").getTime();
      const now = new Date().getTime();
      const difference = conferenceDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section id="home" className="hero">
      <div className="hero-video-container">
        <video
          autoPlay
          muted
          loop
          playsInline
          poster="logo_image.png"
          className="hero-video"
        >
          <source src="icettacs_1.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            International Conference on&nbsp;
            <br />
            Emerging Trends&nbsp;
            <br />
            and&nbsp;
            <br />
            Technologies in Applications of&nbsp;
            <br />
            Computer Science
          </h1>
          <p className="hero-date">9th - 10th July 2026</p>
          <br />
          <br />
          <br />

          <p className="hero-location">
            Birla Institute of Technology (BIT), Mesra
            <span className="divider">|</span>
            Lalpur Unit, Ranchi
          </p>

          <div className="countdown">
            <h3>Conference Starts In:</h3>
            <div className="countdown-container">
              <div className="countdown-item">
                <span className="countdown-number">
                  {String(timeLeft.days).padStart(3, "0")}
                </span>
                <span className="countdown-label">Days</span>
              </div>
              <div className="countdown-item">
                <span className="countdown-number">
                  {String(timeLeft.hours).padStart(2, "0")}
                </span>
                <span className="countdown-label">Hours</span>
              </div>
              <div className="countdown-item">
                <span className="countdown-number">
                  {String(timeLeft.minutes).padStart(2, "0")}
                </span>
                <span className="countdown-label">Minutes</span>
              </div>
              <div className="countdown-item">
                <span className="countdown-number">
                  {String(timeLeft.seconds).padStart(2, "0")}
                </span>
                <span className="countdown-label">Seconds</span>
              </div>
            </div>
          </div>

          <div className="hero-buttons">
            <a href="#registration" className="btn btn-primary">
              Submit Paper
            </a>
            {/* <button className="btn btn-secondary">Register Now</button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
